// Gran Canaria: the municipality has no bounds and its stored center is off-centre
// for the island (island spans lon -15.83..-15.35 and lat 27.74..28.18, center is
// lon -15.76, lat 27.96). 0.25 would cut off Las Palmas, Telde and the airport;
// 0.45 covers the whole island and still excludes Tenerife.
export const GEOCODER_FALLBACK_HALF_SIZE_LAT_DEGREES = 0.45
export const GEOCODER_FALLBACK_HALF_SIZE_LNG_DEGREES = 0.45
// Las Palmas de Gran Canaria (capital, Ayuntamiento) is not at the island center and
// users expect capital-first ordering, so it is the proximity bias point. The bbox
// above still covers the whole island.
export const GEOCODER_BIAS_POINT = { lat: 28.1261, lng: -15.428 }
